export class AuthenticationConsoleError extends Error {
  readonly name: string

  readonly __proto__: AuthenticationConsoleError

  constructor(message?: string) {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "AUTHENTICATION_CONSOLE_ERROR"
  }
}
